import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

export const imgBlockBorderRadius = BORDER_RADIUS.bigger12;
